<template>
    <label for="show-prices">
        <input id="show-prices" @change="handleChange" type="checkbox" name="show-prices" v-model="value" class="mr-1" />
        Show Prices
    </label>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps(['defaultValue']);

const emit = defineEmits(['update:modelValue', 'toggle-value']);

const value = ref(props.defaultValue);

function handleChange() {
    emit('update:modelValue', value.value);
    emit('toggle-value', value.value, 'showPercentDiff');
}

watch(() => props.defaultValue, (newValue) => {
    value.value = newValue;
    handleChange();
});
</script>
